import { create } from "zustand";
import { generateCode, getAll } from "../services/service";
export const useStoreLivraison = create((set) => ({
  loading: false,
  codeLoading: false,
  data: [],
  code: null,
  generate: async (ticket) => {
    set({
      codeLoading: true,
      code: null,
    });
    try {
      const code = await generateCode(ticket);
      set({
        code: code.data,
        codeLoading: false,
      });
    } catch (error) {
      set({
        code: null,
      });
    }
  },
  getData: async (url, param, otherParam) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const getItems = await getAll(url, param, otherParam);
      set({
        loading: false,
        data: getItems.data,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
}));
